<template>
    <div>
        <div class="container ">
            <div class="row d-flex justify-content-center">
                <div class="col-md-6 mt-5 mb-5 text-center" v-if="verifyEmail">
                    <span class="material-icons md-48 text-primary mb-3">beenhere</span>
                    <h1 class="mb-3">¡Gracias!</h1>
                    <p>Tu correo electrónico ha sido verificado</p>
                    <routerLink to="/login" class="btn btn-primary mt-3">Continuar</routerLink>
                </div>
                <div class="col-md-6 mt-5 mb-5 text-center" v-if="resetPassword">
                    <span class="material-icons md-48 text-primary mb-3">password</span>
                    <h1 class="mb-3">{{passEmail}}</h1>
                    <p>Ingresa la nueva contraseña</p>
                    <input class="form-control" type="password" placeholder="Nueva contraseña" v-model.trim="newPass">
                    <input class="form-control mt-3" type="password" placeholder="Confirmar nueva contraseña"
                        v-model.trim="confirmPass">
                    <button class="btn btn-primary mt-3" @click='changePass()'>Continuar
                    </button>
                </div>
                <div class="col-md-6 mt-5 mb-5 text-center" v-if="passSuccess">
                    <span class="material-icons md-48 text-primary mb-3">beenhere</span>
                    <h1 class="mb-3">¡Gracias!</h1>
                    <p>Tu contraseña ha sido actualizada exitosamente</p>
                    <routerLink to="/login" class="btn btn-primary mt-3">Continuar</routerLink>
                </div>
                <div class="col-md-6 mt-5 mb-5 text-center" v-if="errorMessage">
                    <span class="material-icons md-48 text-warning mb-3">error</span>
                    <h1 class="mb-3">Advertencia</h1>
                    <p>{{errDisplay}}</p>
                    <routerLink to="/login" class="btn btn-primary mt-3">Continuar</routerLink>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    var config = require('../config/api.json')
    const API = config.api
    import {  applyActionCode,  verifyPasswordResetCode, confirmPasswordReset } from "firebase/auth";
    import validator from 'validator';

    import { auth } from "@/fb";



    export default {
        name: 'Verify',
        data() {
            return {
                isDarkMode: false,
                uId: null,
                displayName: null,
                photoURL: null,
                loading: false,
                uEmail: null,
                uPass: null,
                showLogin: true,
                showRecovery: false,
                recoveryMail: null,
                showRoute: null,
                resetPassword: false,
                verifyEmail: false,
                errorMessage: false,
                errDisplay: null,
                newPass: null,
                confirmPass: null,
                authPass:null,
                actionCodePass:null,
                passSuccess:false
            }
        },
        beforeMount() {
            var vm = this;
            vm.resetPassword = false
            vm.verifyEmail = false
            vm.errorMessage = false
            if (this.$route.query) {
                const mode = this.$route.query.mode
                const actionCode = this.$route.query.oobCode;
                const apiKey = this.$route.query.apiKey;

                if (!mode) {
                    vm.openNotification('Error', 'Los datos están corruptos, por favor intenta obtener otro correo')
                    return
                }
                if (!actionCode) {
                    vm.openNotification('Error', 'Los datos están corruptos, por favor intenta obtener otro correo')
                    return
                }
                if (!apiKey) {
                    vm.openNotification('Error', 'Los datos están corruptos, por favor intenta obtener otro correo')
                    return
                }

                switch (mode) {
                    case 'resetPassword':
                        this.handleResetPassword(auth, actionCode);
                        break;
                    case 'verifyEmail':
                        this.handleVerifyEmail(auth, actionCode);
                        break;
                    default:
                        vm.openNotification('Error', 'Los datos están corruptos, por favor intenta obtener otro correo')
                        return;
                }
            }
        },
        mounted() {

            window.scrollTo({ top: 0, behavior: 'smooth' });

        },
        methods: {

            changePass() {
                var vm = this
                if(!vm.newPass){
                    vm.openNotification('Error', 'Por favor ingresa tu nueva contraseña')
                    return;
                }
                if(vm.newPass.length<6){
                    vm.openNotification('Error', 'La contraseña debe tener al menos 6 caracteres')
                    return;
                }
                if(vm.confirmPass != vm.newPass){
                    vm.openNotification('Error', 'Las contraseñas no coinciden')
                    return;
                }
                confirmPasswordReset(vm.authPass, vm.actionCodePass, vm.newPass).then((resp) => {
                    vm.resetPassword=false
                    vm.passSuccess=true
                }).catch((error) => {
                    if(error.code='auth/weak-password'){
                        vm.openNotification('Error', 'La contraseña debe tener al menos 6 caracteres')
                        return;
                    }else{
                        vm.errorMessage = true
                        vm.errDisplay = 'Este enlace de verificación ha expirado o fue usado previamente, por favor ve al panel de control'
                    }
                });
            },


            handleResetPassword(auth, actionCode) {
                var vm = this
                verifyPasswordResetCode(auth, actionCode).then((email) => {
                    vm.passEmail = email;
                    vm.resetPassword = true;
                    vm.authPass = auth
                    vm.actionCodePass = actionCode
                }).catch((error) => {
                    vm.errorMessage = true
                    if (error.code == "auth/invalid-action-code") {
                        vm.errDisplay = 'Este enlace de verificación ha expirado o fue usado previamente, por favor ve al panel de control'
                    } else {
                        vm.errDisplay = 'Los datos están corruptos, por favor intenta obtener otro correo'
                    }
                });
            },

            handleVerifyEmail(auth, actionCode) {
                var vm = this
                applyActionCode(auth, actionCode).then((resp) => {
                    this.verifyEmail = true
                }).catch((error) => {
                    vm.errorMessage = true
                    if (error.code == "auth/invalid-action-code") {
                        vm.errDisplay = 'Este enlace de verificación ha expirado o fue usado previamente, por favor ve al panel de control'
                    } else {
                        vm.errDisplay = 'Los datos están corruptos, por favor intenta obtener otro correo'
                    }
                });
            },

            sendRecovery() {
                var vm = this
                if (!vm.recoveryMail) {
                    vm.openNotification('Error', 'El correo está vacío')
                    return
                }
                if (!validator.isEmail(vm.recoveryMail)) {
                    vm.openNotification('Error', 'Por favor ingresa un correo válido')
                    return
                }
                sendPasswordResetEmail(auth, vm.recoveryMail)
                    .then(() => {
                        vm.openNotification('Excelente', '☑️ Recibirás un correo en breve para recuperar tu contraseña')
                        vm.recoveryMail = null
                        return
                    })
                    .catch((error) => {
                        const errorCode = error.code;
                        const errorMessage = error.message;
                        vm.openNotification('Error', `${errorCode}`)
                        vm.recoveryMail = null
                        return
                    });
            },

            openLoading() {
                this.loading = this.$vs.loading({
                    target: this.$refs.content,
                    color: 'dark'
                })
            },

            closeLoading() {
                setTimeout(() => {
                    this.loading.close()
                }, 1000);
            },

            openNotification(title, message) {
                const noti = this.$vs.notification({
                    position: 'bottom-center',
                    color: 'dark',
                    title: title,
                    text: message
                })
            },

        },
    }
</script>